module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Password Reset')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "box login-box text-center"
  }, [_c('p'), _c('div', [_vm._v(_vm._s(_vm.$t('reset_password.input_new_password')))]), _c('p'), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('New Password')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.password_rule
    },
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.password_rule),
      expression: "!validation.password_rule"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.password_rule')))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('New Password Retyped')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_retyped),
      expression: "password_retyped"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.password_retyped
    },
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password_retyped"
    },
    domProps: {
      "value": _vm._s(_vm.password_retyped)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_retyped = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.password_retyped),
      expression: "!validation.password_retyped"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.password_confirmation')))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      disabled: !_vm.validation.not_input
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('reset_password.reset_cancel.message1')))]), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t('Login')))]), _c('span', [_vm._v(_vm._s(_vm.$t('reset_password.reset_cancel.message2')))])], 1), (_vm.showMessage) ? _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "alert",
    class: {
      'alert-success': _vm.isResetPasswordSuccess, 'alert-danger': !_vm.isResetPasswordSuccess
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message))])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29df2624!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/reset-password.pug
// module id = 791
// module chunks = 1